
export default [
    {
        name: 'countertop', 
        variations: [
            {   
                id: 2,
                pathBaseColor: '/assets/cocina/variation_2/baseColor_Meson.jpg',
                pathNormal: '/assets/cocina/variation_2/normal_Meson.jpg',
                pathORM: '/assets/cocina/variation_2/orm_Meson.jpg',
            },  
        ]
    },
    {
        name: 'kitchenIsland', 
        variations: [
            {
                id: 2,
                pathBaseColor: '/assets/cocina/variation_2/baseColor_Structure.jpg',
                pathNormal: '/assets/cocina/variation_2/normal_Structure.jpg',
                pathORM: '/assets/cocina/variation_2/orm_Structure.jpg',
            }
        ]
    },
    {
        name: 'drawers', 
        variations: [
            {
                id: 2,
                pathBaseColor: '/assets/cocina/variation_2/baseColor_Door.jpg',
                pathNormal: '/assets/cocina/variation_2/normal_Door.jpg',
                pathORM: '/assets/cocina/variation_2/orm_Door.jpg',
            }
        ]
    },
    {
        name: 'sink', 
        variations: [
            {
                id: 2,
                pathBaseColor: '/assets/cocina/variation_2/baseColor_Lavado.jpg',
                pathNormal: '/assets/cocina/variation_2/normal_Lavado.jpg',
                pathORM: '/assets/cocina/variation_2/orm_Lavado.jpg',
            }
        ]
    },
    {
        name: 'faucet', 
        variations: [
            {
                id: 2,
                pathBaseColor: '/assets/cocina/variation_2/baseColor_Faucet.jpg',
                pathNormal: '/assets/cocina/variation_2/normal_Faucet.jpg',
                pathORM: '/assets/cocina/variation_2/orm_Faucet.jpg',
            }
        ]
    }, 
    {
        name: 'islandBase', 
        variations: [
            {
                id: 2,
                pathBaseColor: '/assets/cocina/variation_2/baseColor_BaseIsla.jpg',
                pathNormal: '/assets/cocina/variation_2/normal_BaseIsla.jpg',
                pathORM: '/assets/cocina/variation_2/orm_BaseIsla.jpg'
            }
        ]
    } 
]
